module.exports = __webpack_public_path__ + "media/images/icons/white-search-a5ad69e3b2ebb71f9c156d62c2fbc549.svg";